import React from 'react'
import OpenLmisHome from '../Components/OpenLmisComponents/OpenLmisHome'
import OpenLmisFeatures from '../Components/OpenLmisComponents/OpenLmisFeatures'
import OpenLmisImpact from '../Components/OpenLmisComponents/OpenLmisImpact'

function OpenLmis() {
  return (
    <div className='openLmispage'>
      <OpenLmisHome />
      <OpenLmisFeatures />
      <OpenLmisImpact />
    </div>
  )
}

export default OpenLmis
